import { ChangeDetectorRef, Component, Input, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges  } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import { Observable, Subscription, map, of, startWith } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { MapService } from 'src/app/services/map.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';
interface Cervezas{
  value: number;
  name: string;
}
interface TanqueDisponible {
  deviceId: number;
  slots: number[];
}
interface Clientes{
  value: number;
  name: string;
}
export interface Dispositivo {
  label: string;
  deviceId: number;
  estalbishmentId: number;
}
@Component({
  selector: 'app-agregar-tanque',
  templateUrl: './agregar-tanque.component.html',
  styleUrls: ['./agregar-tanque.component.css']
})
export class AgregarTanqueComponent implements OnInit, OnDestroy{

  lat: number = 43.0081016;
  lng: number = -7.5561412;
  zoom: number = 14;
  addressData: any;

  identificadorCliente: string = "";
  nTanque: string = "";
  dispositivoCreado: boolean = false;
  errorMessage : string =""; //Mensaje de error
  errorFinal: boolean = false;
  waitAfterSave: boolean = false;
  cervezas: Cervezas[] = []

  //ERROR
  campoObligatorioError: boolean = false;
  dispositivoError: boolean = false;
  cervezaError: boolean = false;
  capacidadError: boolean = false;
  numeroTanqueError: boolean = false;
  customNumeroTanqueError: boolean = false;

  //DATA
  establishmentsData: any;
  devicesData: any;

  //CLIENTES
  clientes: Clientes[] = [
  ];
  selectedCliente: number | undefined;

  //TANQUES DISPONIBLES
  numeroTanqueDisponibles: TanqueDisponible[] = [];
  slotsDisponibles: number[] = [];
  tanqueSeleccionado: number | undefined;
  mostrarHint = true;

  //CAPACIDAD TANQUE
  capacidadFormGroup: FormGroup = new FormGroup({
    capacidadTanque: new FormControl('',[Validators.pattern(/^(-?\d+(\.\d+)?|\d+(\,\d+)?)$/)])
  });

  //POSICION CUSTOM
  customPositionFormGroup: FormGroup = new FormGroup({
    customPosition: new FormControl('', [Validators.pattern(/^\d+$/)])
  });

  //CERVEZA SELECCIONADA
  cervezasControl: FormControl = new FormControl();
  cervezaSeleccionada: string = "";
  map: any; 
  marker: any;

  //CONFIGURACIÓN DE ALARMAS
  configuracionAlarmas: FormGroup = new FormGroup({
    nivelCerveza: new FormControl('', [
      Validators.min(0),
      Validators.max(100),
      (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) {
          return null;
        }
        //Tenemos que substituir la coma por el punto para que realice bien la comprobación
        const sanitizedValue = value.replace(',', '.');
        if (!/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/.test(sanitizedValue)) {
          return { pattern: true };
        }
        const numericValue = parseFloat(sanitizedValue);
        if (isNaN(numericValue)) {
          return { pattern: true };
        }
    
        if (numericValue < 0) {
          return { min: true };
        }
        if (numericValue > 100) {
          return { max: true };
        }
        return null;
      },
    ]),
    temperaturaTanqueMin: new FormControl('', [Validators.pattern(/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/)]),
    temperaturaTanqueMax: new FormControl('', [Validators.pattern(/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/)]),
    presionMax: new FormControl('', [Validators.pattern(/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/)]),
    presionMin: new FormControl('', [Validators.pattern(/^(-?\d+(\.\d+)?|-?\d+(\,\d+)?)$/)]),
  });

  errorCamposIncorrectos: boolean = false;
  //selectedDispositivo: any | undefined;
  userData: any = [];
  establecimientoNombre: string = "";

  //AUTOCOMPLETE
  myControl = new FormControl<string | Dispositivo>('');
  autocompleteDispositivos: Dispositivo [] = [];
  filteredOptions!: Observable<Dispositivo[]>;

  //Subscripciones
  private establishmentsSubscription: Subscription | undefined;
  private devicesSubscription: Subscription | undefined;
  private beerTypesSubscription: Subscription | undefined;
  private clientsSubscription: Subscription | undefined;
  private agregarTanqueSubscription: Subscription | undefined;

  @Input() userId: any;

  constructor(private userDataService: UserDataService ,private deviceService: DeviceService, private mapService: MapService,
    private error429: Error429Service, private formBuilder: FormBuilder, private userService : UserService, private cdr: ChangeDetectorRef){
      this.userData = this.userDataService.getUserData();
    }

  ngOnInit(): void {
    //Datos de los establecimientos
    this.devicesSubscription = this.deviceService.getDevicesDataNew().subscribe({
      next: resp =>{
        this.devicesData = resp.filter((device:any) => !device.locked);
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () =>{
        this.establishmentsSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
          next:resp =>{
            this.establishmentsData = resp;
          },error:err =>{
            if (err.status == 429) {
              this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
              this.recargarPaginaDespuesDeTiempo();
            } else {
              this.errorMessage = err.error.message;
            }
          }, complete: () =>{
            for (let i = 0; i < this.devicesData.length; i++) {
              //Slots disponibles
                const tanquesDisponibles: TanqueDisponible = {
                  deviceId: this.devicesData[i].id,
                  slots: []
                };
                if (this.devicesData[i].tanks.length !== 0) {
                  for (let j = 0; j < this.devicesData[i].tanks.length; j++) {
                    if (this.devicesData[i].tanks[j].slot) {
                      tanquesDisponibles.slots.push(this.devicesData[i].tanks[j].slot);
                    }
                  }
                }
                // Incluso si no hay slots ocupados, agregamos el objeto tanquesDisponibles a la lista
                this.numeroTanqueDisponibles.push(tanquesDisponibles);
              //Autocomplete
                this.autocompleteDispositivos.push({
                  label: this.devicesData[i].dev_label + ' ('+this.devicesData[i].dev_reference + ')',
                  deviceId: this.devicesData[i].id,
                  estalbishmentId: this.devicesData[i].dev_est_id
                });
            }
            this.filteredOptions = this.myControl.valueChanges.pipe(
              startWith(''),
              map(value => {
                const label = typeof value === 'string' ? value : value?.label;
                return label ? this._filter(label as string) : this.autocompleteDispositivos.slice();
              }),
            );
            this.mapService.loadMapScript(this.initMap.bind(this));
          }
        });
      }
    });
    //Tipos de cerveza
    this.cervezasControl = this.formBuilder.control([]);
    this.beerTypesSubscription = this.deviceService.getBeerType().subscribe({
      next:resp =>{
        this.cervezas = resp.map((item: any) => ({ value: item.id, name: item.name }));
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }
    });
    //Clientes
    if(this.userData.pro_id == 4){
      this.clientsSubscription = this.userService.getClients().subscribe({
        next:resp =>{
          for(let i=0; i<resp.length; i++){
            this.clientes.push({
              value: resp[i].id,
              name: resp[i].razon_social
            });
          }
        },error:err =>{
          if (err.status == 429) {
            this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
            this.recargarPaginaDespuesDeTiempo();
          } else {
            this.errorMessage = err.error.message;
          }
        }, complete: () =>{}
      });
    }
  }

  //Función para después de guardar un nuevo tanque satisfactoriamente volver a calcular los dispositivos
  //con sus slots disponibles.
  comprobarSlotsOcupadosyDispositivos(){
    //Necesario volver a hacer la llamada
    this.devicesSubscription = this.deviceService.getDevicesDataNew().subscribe({
      next:resp =>{
        this.devicesData = resp.filter((device:any) => !device.locked);
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: () =>{
        this.numeroTanqueDisponibles = [];
        this.autocompleteDispositivos = [];
        for (let i = 0; i < this.devicesData.length; i++) {
          //Slots disponibles
          const tanquesDisponibles: TanqueDisponible = {
            deviceId: this.devicesData[i].id,
            slots: []
          };
          if (this.devicesData[i].tanks.length !== 0) {
            for (let j = 0; j < this.devicesData[i].tanks.length; j++) {
              if (this.devicesData[i].tanks[j].slot) {
                tanquesDisponibles.slots.push(this.devicesData[i].tanks[j].slot);
              }
            }
          }
          // Incluso si no hay slots ocupados, agregamos el objeto tanquesDisponibles a la lista
          this.numeroTanqueDisponibles.push(tanquesDisponibles);
          //Autocomplete
          this.autocompleteDispositivos.push({
            label: this.devicesData[i].dev_label + ' ('+this.devicesData[i].dev_reference + ')',
            deviceId: this.devicesData[i].id,
            estalbishmentId: this.devicesData[i].dev_est_id
          });
        }
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => {
            const label = typeof value === 'string' ? value : value?.label;
            return label ? this._filter(label as string) : this.autocompleteDispositivos.slice();
          }),
        );
        console.log(this.autocompleteDispositivos);
        this.initMap();
      }
    });
  }

  initMap(){
    const mapElement = document.getElementById('map');
    // Verificar si el elemento existe antes de intentar trabajar con él
    if (mapElement) {
      const mapOptions = {
        center: { lat: this.lat, lng: this.lng },
        zoom: this.zoom,
      };
      this.map = new google.maps.Map(mapElement, mapOptions);
      this.marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lng },
        map: this.map,
        draggable: false,
        title: 'Marcador'
      });
    } else {
      console.error('Elemento del mapa no encontrado en el DOM.');
    }
    this.getAddress(this.lat, this.lng);
  }

  private _filter(name: string): Dispositivo[] {
    const filterValue = name.toLowerCase();

    return this.autocompleteDispositivos.filter(option => option.label.toLowerCase().includes(filterValue));
  }

  displayFn(dispositivo: Dispositivo): string {
    return dispositivo && dispositivo.label ? dispositivo.label : '';
  }

  tieneErrorNivelCerveza(): boolean {
    const control = this.nivelCervezaInput;
    const value = control?.value;
    if (value !== null && value !== undefined && value !== '' && !value) {
      // Utiliza una expresión regular que verifica si el valor es "100, número"
      const regex = /^100,\d+(\.\d+)?$/; 
      return !regex.test(value.toString());
    }
    return false;
  }

  get capacidadTanqueInput() { 
    return this.capacidadFormGroup.get('capacidadTanque'); 
  }
  get customPositionInput() { 
    return this.customPositionFormGroup.get('customPosition'); 
  }
  get nivelCervezaInput() { 
    return this.configuracionAlarmas.get('nivelCerveza'); 
  }
  get temperaturaTanqueMinInput() { 
    return this.configuracionAlarmas.get('temperaturaTanqueMin'); 
  }
  get temperaturaTanqueMaxInput() { 
    return this.configuracionAlarmas.get('temperaturaTanqueMax'); 
  }
  get presionMinInput() { 
    return this.configuracionAlarmas.get('presionMin'); 
  }
  get presionMaxInput() { 
    return this.configuracionAlarmas.get('presionMax'); 
  }

  ngOnDestroy(): void {
    if (this.establishmentsSubscription) {
      this.establishmentsSubscription.unsubscribe();
    } 
    if (this.beerTypesSubscription) {
      this.beerTypesSubscription.unsubscribe();
    } 
    if (this.devicesSubscription) {
      this.devicesSubscription.unsubscribe();
    } 
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
    if (this.agregarTanqueSubscription) {
      this.agregarTanqueSubscription.unsubscribe();
    } 
  }

  getAddress(latitude: number, longitude: number) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: {lat: latitude, lng: longitude} }).then((response) => {
      //la posicion 0 es el lugar más cercano al click
      if(response.results[0]) {
        this.addressData = response.results[0].formatted_address;
        this.cdr.detectChanges();
      } else{
        console.log(window.alert("No hay resultados"));
      }
    })
  }

  cambiarNombreEstablecimiento(deviceId: number){
    const device = this.devicesData.find((device:any)=> device.id == deviceId);
    this.establecimientoNombre = device.establishment.est_name;
  }

  /*updateEstadoDispositivo() {
    if (this.selectedDispositivo == undefined) {
        this.campoObligatorioError = true;
        this.mostrarHint = true;
    } else {
        this.campoObligatorioError = false;
        this.mostrarHint = false;
        //COORDENADAS ESTABLECIMIENTO
        const coordenadas = this.obtenerCoordenadasEstablecimiento(this.selectedDispositivo.estalbishmentId);
        this.lat = coordenadas.est_lat;
        this.lng = coordenadas.est_lng;
        this.getAddress(this.lat, this.lng);
        this.marker.setPosition({ lat: this.lat, lng: this.lng });
        this.map.setCenter({ lat: this.lat, lng: this.lng });
        //SLOTS DISPONIBLES EN EL DISPOSITIVO
        const deviceId = this.selectedDispositivo.deviceId;

        // Buscar el dispositivo en numeroTanqueDisponibles
        const dispositivoEncontrado = this.numeroTanqueDisponibles.find(dispositivo => dispositivo.deviceId === deviceId);
    
        if (dispositivoEncontrado) {
          // Obtener los slots ocupados en el dispositivo
          const slotsOcupados = dispositivoEncontrado.slots;
    
          // Generar la lista de slots disponibles restando los ocupados del conjunto completo de slots
          const todosLosSlots = [1, 2, 3, 4]; // 4 slots disponibles por el momento
          this.slotsDisponibles = todosLosSlots.filter(slot => !slotsOcupados.includes(slot));
    
          console.log('Slots disponibles:', this.slotsDisponibles);
        } else {
          console.error('Dispositivo no encontrado en numeroTanqueDisponibles');
        }
    }
  }*/

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedDispositivo: string | Dispositivo | null = this.myControl.value;
    console.log(selectedDispositivo);
    if (selectedDispositivo && typeof selectedDispositivo !== 'string') {
      //El dispositivo ha sido elegido
      this.cambiarNombreEstablecimiento(selectedDispositivo.deviceId);
      console.log(selectedDispositivo.deviceId);
      console.log(selectedDispositivo.estalbishmentId);
      this.campoObligatorioError = false;
      this.mostrarHint = false;
      //COORDENADAS ESTABLECIMIENTO
      const coordenadas = this.obtenerCoordenadasEstablecimiento(selectedDispositivo.estalbishmentId);
      this.lat = coordenadas.est_lat;
      this.lng = coordenadas.est_lng;
      this.getAddress(this.lat, this.lng);
      this.marker.setPosition({ lat: this.lat, lng: this.lng });
      this.map.setCenter({ lat: this.lat, lng: this.lng });
      //SLOTS DISPONIBLES EN EL DISPOSITIVO
      const deviceId = selectedDispositivo.deviceId;
      // Buscar el dispositivo en numeroTanqueDisponibles
      const dispositivoEncontrado = this.numeroTanqueDisponibles.find(dispositivo => dispositivo.deviceId === deviceId);
      if (dispositivoEncontrado) {
        // Obtener los slots ocupados en el dispositivo
        const slotsOcupados = dispositivoEncontrado.slots;
        // Generar la lista de slots disponibles restando los ocupados del conjunto completo de slots
        const todosLosSlots = [1, 2, 3, 4];
        this.slotsDisponibles = todosLosSlots.filter(slot => !slotsOcupados.includes(slot));
        console.log('Slots disponibles:', this.slotsDisponibles);
      } else {
        console.error('Dispositivo no encontrado en numeroTanqueDisponibles');
      }
    } else {
      this.campoObligatorioError = true;
      this.mostrarHint = true;
    }
  }

  obtenerCoordenadasEstablecimiento(id: number) {
    const establishment = this.establishmentsData.find((establishment:any) => establishment && establishment.id === id);
    if(establishment){
      return {
        est_lat: establishment.est_lat,
        est_lng: establishment.est_lng
      }
    } else {
      return {
        est_lat: null,
        est_lng: null
      }
    }
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  limpiarSeleccion(): void {
    this.myControl.setValue('');
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const label = typeof value === 'string' ? value : value?.label;
        return label ? this._filter(label as string) : this.autocompleteDispositivos.slice();
      }),
    );
    this.slotsDisponibles = [];
    this.establecimientoNombre = "";
  }

  guardarDispositivo() {
    this.errorCamposIncorrectos = false;
    this.campoObligatorioError = false;

    //Autocomplete
    const selectedDispositivo: string | Dispositivo | null = this.myControl.value;
    if (selectedDispositivo && typeof selectedDispositivo !== 'string') {
      //El dispositivo ha sido elegido
      this.campoObligatorioError = false;
      this.dispositivoError = false;
    } else {
      this.campoObligatorioError = true;
      this.dispositivoError = true;
    }
    console.log(this.myControl.value);

    /*if(this.selectedDispositivo == undefined){
      this.dispositivoError = true;
    } else {
      this.dispositivoError = false;
    }*/

    if(this.cervezasControl.pristine || !this.cervezasControl.touched){
      this.cervezaError = true;
    } else {
      this.cervezaError = false;
    }

    if (!this.capacidadTanqueInput?.value || this.capacidadTanqueInput?.value.trim() === '') {
      this.capacidadError = true;
    } else {
      this.capacidadError = false;
    }

    //Comprobar que el tanque seleccionado está en la lista de slots disponibles para el dispositivo
    let estaEnLaLista = false;
    if(this.tanqueSeleccionado != undefined){
      estaEnLaLista = this.slotsDisponibles.includes(this.tanqueSeleccionado);
    } else {
      this.numeroTanqueError = false;
    }
    if(!estaEnLaLista){
      this.tanqueSeleccionado = undefined;
      this.numeroTanqueError = true;
    } else {
      this.numeroTanqueError = false;
    }

    if (!this.customPositionInput?.value || this.customPositionInput?.value.trim() === '') {
      this.customNumeroTanqueError = true;
    } else {
      this.customNumeroTanqueError = false;
    }

    //Comprobar si hay campos obligatorios sin cubrir
    if (this.dispositivoError || this.cervezasControl.pristine || !this.cervezasControl.touched 
      || !this.capacidadTanqueInput?.value || this.capacidadError
      || this.numeroTanqueError || this.customNumeroTanqueError) {
      this.campoObligatorioError = true;
    }

    //Comprobar si hay campos introducidos incorrectamente
    if(this.configuracionAlarmas.get('nivelCerveza')?.hasError('pattern') || this.configuracionAlarmas.get('nivelCerveza')?.hasError('min')
    || this.configuracionAlarmas.get('nivelCerveza')?.hasError('max') || this.configuracionAlarmas.get('temperaturaTanqueMin')?.hasError('pattern')
    || this.configuracionAlarmas.get('temperaturaTanqueMax')?.hasError('pattern') || this.configuracionAlarmas.get('presionMax')?.hasError('pattern')
    || this.configuracionAlarmas.get('presionMin')?.hasError('pattern') || this.capacidadFormGroup.get('capacidadTanque')?.hasError('pattern') 
    || this.customPositionFormGroup.get('customPosition')?.hasError('pattern')){
      this.errorCamposIncorrectos = true;
    }

    if(!this.campoObligatorioError && !this.errorCamposIncorrectos && selectedDispositivo && typeof selectedDispositivo !== 'string'){

      //Cambiar la coma por el punto en caso de ser necesario para enviarselo al servidor

      const alarmas = {
        beerLevelMin: this.nivelCervezaInput?.value && typeof this.nivelCervezaInput.value === 'string'
          ? parseFloat(this.nivelCervezaInput.value.replace(',', '.'))
          : parseFloat(this.nivelCervezaInput?.value),
        beerTemperatureMin: this.temperaturaTanqueMinInput?.value && typeof this.temperaturaTanqueMinInput.value === 'string'
          ? parseFloat(this.temperaturaTanqueMinInput.value.replace(',', '.'))
          : parseFloat(this.temperaturaTanqueMinInput?.value),
        beerTemperatureMax: this.temperaturaTanqueMaxInput?.value && typeof this.temperaturaTanqueMaxInput.value === 'string'
          ? parseFloat(this.temperaturaTanqueMaxInput.value.replace(',', '.'))
          : parseFloat(this.temperaturaTanqueMaxInput?.value),
        beerPressureMin: this.presionMinInput?.value && typeof this.presionMinInput.value === 'string'
          ? parseFloat(this.presionMinInput.value.replace(',', '.'))
          : parseFloat(this.presionMinInput?.value),
        beerPressureMax: this.presionMaxInput?.value && typeof this.presionMaxInput.value === 'string'
          ? parseFloat(this.presionMaxInput.value.replace(',', '.'))
          : parseFloat(this.presionMaxInput?.value),
      };
      const jsonData = JSON.stringify(alarmas);

      let valorCapacidad = this.capacidadTanqueInput?.value;
      if (typeof valorCapacidad === 'string') {
        valorCapacidad = valorCapacidad.replace(',', '.');
        valorCapacidad = parseFloat(valorCapacidad);
      }

      const tanqueData = new FormData();
      tanqueData.append('_method', "PUT");
      tanqueData.append('device_id', selectedDispositivo.deviceId.toString() || '');
      tanqueData.append('beer_type_id', this.cervezasControl?.value);
      tanqueData.append('external_id', this.identificadorCliente);
      tanqueData.append('capacity', valorCapacidad);
      tanqueData.append('slot', this.tanqueSeleccionado?.toString() || '');
      tanqueData.append('custom_num', this.customPositionInput?.value);
      tanqueData.append('alarm_ranges', jsonData);
      tanqueData.append('cliente_id', this.selectedCliente?.toString() || '');

      this.agregarTanqueSubscription = this.deviceService.createTank(tanqueData).subscribe({
        next: resp => {
          console.log(resp);
        },error: err =>{
          console.log(err);
          this.errorMessage = err.error.message;
          console.log(this.errorMessage);
          if(this.errorMessage == undefined){
            this.errorMessage = err.error.error;
            console.log(this.errorMessage);
          }
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.errorFinal = true;
            setTimeout(() => {
              this.errorFinal = false;
              this.waitAfterSave = false;
            },3500)
          }
        }, complete: () =>{
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.dispositivoCreado = true;
            setTimeout(() => {
              this.limpiarSeleccion();
              this.comprobarSlotsOcupadosyDispositivos();
              this.lat = 43.0081016;
              this.lng = -7.5561412;
              this.getAddress(this.lat, this.lng);
              this.identificadorCliente = "";
              this.capacidadFormGroup.setValue({
                capacidadTanque: '',
              });
              this.customPositionFormGroup.setValue({
                customPosition: '',
              });
              this.selectedCliente = undefined;
              this.tanqueSeleccionado = undefined;
              this.cervezasControl.reset();
              console.log(this.myControl.value);
              this.configuracionAlarmas.setValue({
                nivelCerveza: '',
                temperaturaTanqueMin: '',
                temperaturaTanqueMax: '',
                presionMin: '',
                presionMax: ''
              });
              this.waitAfterSave = false;
              this.dispositivoCreado = false;
            }, 3500);
          }
        }
      })
    }

    const alarmas = {
      nivelCerveza: this.nivelCervezaInput?.value,
      temperaturaTanqueMin: this.temperaturaTanqueMinInput?.value,
      temperaturaTanqueMax: this.temperaturaTanqueMaxInput?.value,
      presionMin: this.presionMinInput?.value,
      presionMax: this.presionMaxInput?.value
    };
    const jsonData = JSON.stringify(alarmas);

    /*console.log('Identificador del cliente:', this.identificadorCliente);
    console.log('Numero de tanque personalizado:', this.customPositionInput?.value);
    console.log('Numero de tanque:', this.tanqueSeleccionado);
    console.log('Capacidad de tanque:', this.capacidadTanqueInput?.value);
    console.log('Cerveza seleccionada: ', this.cervezasControl.value);

    console.log('Nivel mínimo de cerveza(%): ',this.nivelCervezaInput?.value);
    console.log('Temperatura mínima tanque: ',this.temperaturaTanqueMinInput?.value);
    console.log('Temperatura máxima tanque: ',this.temperaturaTanqueMaxInput?.value);
    console.log('Presion mínima: ',this.presionMinInput?.value);
    console.log('Presion máxima: ',this.presionMaxInput?.value);
    console.log('Alarmas json: ', jsonData);

    console.log('Dispositivo seleccionado: ',this.selectedDispositivo);
    console.log('Cliente seleccionado: ', this.selectedCliente);

    console.log("--------------------------------");*/
  }

}

